const getters = {
  isLoading: state => state.isLoading,
  list: state => state.list,
  isInvoiceLoading: state => state.isInvoiceLoading,
  invoicelist: state => state.invoicelist,
  isUploading: state => state.isUploading,
  isEmptyPaginate: state => state.isEmptyPaginate,
  filter: state => state.filter,
};

export default getters;
